module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_10.132a220d.jpeg";